import React from "../../../../__snowpack__/pkg/react.js";
export const IconAccount = React.memo((props) => {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    ...props
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(-1285 -16)"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(844 8)"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(434)"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(7 6)"
  }, /* @__PURE__ */ React.createElement("g", {
    transform: "translate(0 2)"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", {
    fill: "#FFF",
    fillOpacity: "0"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M0 0H16V16H0z"
  })), /* @__PURE__ */ React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(1 1)"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M7 6.96c.982 0 1.801-.328 2.456-.983s.983-1.48.983-2.477c0-.996-.328-1.822-.983-2.477C8.801.368 7.982.027 7 0c-.982.027-1.801.368-2.456 1.023-.655.655-.983 1.48-.983 2.477 0 .996.328 1.822.983 2.477.655.655 1.474.982 2.456.982zM14 14v-1.76c-.055-.983-.737-1.801-2.047-2.456S8.993 8.788 7 8.76c-1.992.028-3.643.369-4.953 1.024C.737 10.439.055 11.257 0 12.24V14h14z"
  }))))))))));
});
